<ng-container *ngIf="initialized">
  <app-header title=""></app-header>
  <app-header-dashboard class="d-block" style="min-height: 288px;"></app-header-dashboard>
  <div class="row px-5 py-3" style="background: white;">
      <div class="col-md-7">   
          <span class=" d-block mb-2 subtitle-1--weight-regular">{{activeBtnName}}</span>
          <div class="dashboard-chart mb-5">
              <div class="list-group list-group-light mb-3 period-buttons" style="width: 20%;">
                    <button type="button" (click)="getAllDonationsMTD()" [ngClass]="activeBtn=='mtd'?'active':''" class="list-group-item list-group-item-action  px-3">
                      MTD
                    </button>
                    <button type="button" (click)="getAllDonationsYTD()" [ngClass]="activeBtn=='ytd'?'active':''" class="list-group-item list-group-item-action  px-3">
                      YTD
                    </button>
                    <button type="button" (click)="getAllDonationsLastMonth()" style="min-width: 110px;" [ngClass]="activeBtn=='month'?'active':''" class="list-group-item list-group-item-action  px-3">
                      Last Month
                    </button>
                    <button type="button" (click)="getAllDonationsLastYear()" style="min-width: 100px;" [ngClass]="activeBtn=='year'?'active':''" class="list-group-item list-group-item-action px-3">
                     Last Year
                    </button>
              </div>
              <div class="">
                <div class="row align-items-center">
                  <div class="col col-9">
                    <canvas
                        *ngIf="showChart"
                        class="dashboard-chart-content"
                        mdbChart
                        [type]="'bar'"
                        [datasets]="datasets"
                        [labels]="labels"
                        [options]="options"
                     ></canvas>
                    <span *ngIf="!showChart" style="font-size: 12px;color:#7c8187">No donation for "selected period".</span>
                  </div>
                  <div class="col col-3" style="display: contents;">
                    <div class="d-flex flex-xl-column flex-sm-row flex-md-row  justify-content-center dashboard-chart-info">
                      <div class="d-flex flex-column">
                        <p class="chart-info-subtitle purple-pb mb-0">DONATIONS</p>
                        <span *ngIf="orgDnations" class="chart-info-amount text-center">{{getAmount(orgDnations.totalDonations)}}</span>
                        <a type="button" 
                            *ngIf="showSeeAll"
                            class="button text-center mb-3"
                            style="
                            cursor: pointer;
                            color: #007bff;
                            font-size: 12px;
                            "
                            (click)="onDonationClick()"
                            >
                            See All
                        </a>
                      </div>
                      <div class="d-flex flex-column">
                        <p class="chart-info-subtitle orange-pb mb-0">PENDING</p>
                        <ng-container *ngIf="orgUser">
                          <span class="chart-info-amount text-center">{{getAmount(orgUser.pendingAmount)}}</span>
                        </ng-container> 
                        <a type="button" 
                          *ngIf="showSeeAll"
                          class="button text-center"
                          style="
                          cursor: pointer;
                          color: #007bff;
                          font-size: 12px;
                          "
                          (click)="onPendingClick()">
                          See All
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
          <app-upcoming-reminders></app-upcoming-reminders>
          <app-dashboard-swiper></app-dashboard-swiper>
      </div>
      <div class="col-md-5 p-0 pl-5">
        <app-dashboard-get-start-buttons></app-dashboard-get-start-buttons>
        <app-let-us-help-you></app-let-us-help-you>        
        <app-refer-a-friend></app-refer-a-friend>
        <app-dashboard-donor-table></app-dashboard-donor-table>
      </div>
  </div>
</ng-container>

